<template>
  <section class="w-full py-12 md:py-24 full-height flex justify-center items-center" id="about">
    <div class="container px-4 md:px-6">
      <div class="flex flex-col items-center text-center space-y-4">
        <h2 class="text-3xl font-bold tracking-tight sm:text-6xl">
          Struggling to Stay Consistent?
        </h2>
        <p class="max-w-[900px] text-gray-500 text-lg md:text-2xl leading-relaxed">
          Growing your social media presence takes time and dedication, but staying consistent can be challenging.
        </p>
      </div>

      <div class="mt-10 grid gap-6 lg:grid-cols-3 max-w-5xl mx-auto">
        <!-- Problem Section -->
        <div class="flex flex-col items-center space-y-4 text-center">
          <h3 class="text-2xl font-bold text-gray-800">
            <font-awesome-icon :icon="['fas', 'exclamation-triangle']" class="mr-2" />
            The Challenge
          </h3>
          <p class="text-lg text-gray-500">
            Social media success requires regular posting and engagement. But in a busy world, staying on top of that isn’t easy.
          </p>
        </div>

        <!-- Solution Section -->
        <div class="flex flex-col items-center space-y-4 text-center">
          <h3 class="text-2xl font-bold text-gray-800">
            <font-awesome-icon :icon="['fas', 'lightbulb']" class="mr-2" />
            Our Solution
          </h3>
          <p class="text-lg text-gray-500">
            We make social media growth fun and engaging by turning your activity into a game. Gain achievements, complete missions, and compete with others.
          </p>
        </div>

        <!-- How it Works Section -->
        <div class="flex flex-col items-center space-y-4 text-center">
          <h3 class="text-2xl font-bold text-gray-800">
            <font-awesome-icon :icon="['fas', 'cogs']" class="mr-2" />
            How It Works
          </h3>
          <p class="text-lg text-gray-500">
            Connect your accounts, take on daily missions, and watch your score rise. Earn points for consistency and climb the leaderboard to boost your exposure.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
</script>

<style scoped>
.full-height {
  height: 100vh;
}
</style>